import type { CustomerType } from "../CustomerType.js";
import type { DeliveryType } from "../DeliveryType.js";
import type { OrderStop } from "../OrderStop.js";
import { orderStopToDeliveryTypeAndCustomerTypeMap } from "../orderStopToDeliveryTypeAndCustomerTypeMap.js";

export function isDeliveryTypeInStop(
	deliveryType: DeliveryType,
	customerType: CustomerType,
	orderStops: OrderStop[],
): boolean {
	return orderStops.some((orderStop) => {
		const [stopDeliveryType, stopCustomerType] = orderStopToDeliveryTypeAndCustomerTypeMap[orderStop];
		return stopDeliveryType === deliveryType && stopCustomerType === customerType;
	});
}
